import { createSlice } from '@reduxjs/toolkit'
import { sliceStateStatus } from '@/Core';

import ISliceState from '@/interface/core/ISliceState';
import ISingleMembershipRequest from '@/interface/ISingleMembershipRequest';

import {
  smrIndex,
  smrPaginate,
  smrView,
  smrCountPending 
} from './smrActions'; 

const initialState: ISliceState<ISingleMembershipRequest[] | any> = {
  data: [],
  status: sliceStateStatus.idle,
  
  pendingCount: 0,
};

const smrSlice = createSlice({
  name: 'smr',
  initialState,
  reducers: {
    resetSmrState: () => initialState
  },
  extraReducers: (builder) => {
    builder

      // Index
      .addCase(smrIndex.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(smrIndex.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(smrIndex.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      // Paginate
      .addCase(smrPaginate.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(smrPaginate.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(smrPaginate.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      // View
      .addCase(smrView.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(smrView.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data;
      })
      .addCase(smrView.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      //pending
      .addCase(smrCountPending.fulfilled, (state, action) => {
        state.pendingCount = action.payload.count;
      })

      
  }
});

export const selectSmrPendingCount = (state: any) => state.smr.pendingCount;
export const { resetSmrState } = smrSlice.actions;
export default smrSlice.reducer;
